import React from "react";
import styles from "./HotelCard.module.scss";
import mastiff from "../../../assets/new-icons/mastiff-hotel.svg";
import fab from "../../../assets/new-icons/fab.svg";
import regenta from "../../../assets/new-icons/regenta.svg";
import clarks from "../../../assets/new-icons/clarks.svg";
import royal from "../../../assets/new-icons/royal.svg";
import eco from "../../../assets/new-icons/eco.svg";
import levelup from "../../../assets/new-icons/levelup.svg";
import bestWestern from "../../../assets/new-icons/best-western.svg";

const HotelaChain = () => {
  const hotelsChainData = [
    {
      image: regenta,
      alt: "regenta",
    },
    {
      image: mastiff,
      alt: "mastiff",
    },
    {
      image: clarks,
      alt: "clarks",
    },
    {
      image: fab,
      alt: "fab",
    },
    {
      image: royal,
      alt: "royal",
    },
    {
      image: bestWestern,
      alt: "bestWestern",
    },
    {
      image: levelup,
      alt: "levelup",
    },
    {
      image: eco,
      alt: "eco",
    },
  
  ];
  return (
    // <section className="common_padding">
      <div className={styles.hotels_chain}>
        {" "}
        <div className="container">
          <h4 className="new_ui_heading">Top Hotel Chains With Us</h4>
          <div className={styles.hotels_flex}>
            {hotelsChainData?.map((item, i) => (
              <div key={i}>
                <img src={item?.image} alt={item?.alt} />
              </div>
            ))}
          </div>
        </div>
      </div>
    // </section>
  );
};

export default HotelaChain;
